module.exports = __webpack_public_path__ + "static/media/robot.b52f9b70.png";